import { render } from "./orders_bulk_status.vue?vue&type=template&id=6e685d62"
import script from "./orders_bulk_status.vue?vue&type=script&lang=js"
export * from "./orders_bulk_status.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__